// src/sync/dateSyncDriver.js
import { fetchResource } from '@platform/core/src/services/resourceApi';
import { applyPatchWithPartialProtection, mergeUpdateWithPartialProtection } from './syncUtils';

const transformDate = (resource) => {
  if (!resource) return null;
  return {
    ...resource,
    type: 'date',
    resource_type: 'date',
  };
};

const dateSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      // If value is provided in the event, use it; otherwise fetch
      let newResource = content.value;
      if (!newResource) {
        newResource = await fetchResource(content.resource_type, content.resource_id);
      }
      
      if (!newResource) return currentMap;
      
      const transformed = transformDate(newResource);
      return { ...currentMap, [content.resource_id]: transformed };
    } catch (error) {
      console.error('[dateSyncDriver] Failed to sync created date:', error);
      return currentMap;
    }
  },

  handleUpdated(currentMap, content) {
    if (!content.value) return currentMap;
    const existing = currentMap[content.resource_id];
    const protectedValue = mergeUpdateWithPartialProtection(existing, content.value);
    const transformed = transformDate(protectedValue);
    return { ...currentMap, [content.resource_id]: transformed };
  },

  handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    if (!resourceToPatch) return currentMap;
    try {
      const patched = applyPatchWithPartialProtection(resourceToPatch, content.patches);
      const transformed = transformDate(patched);
      return { ...currentMap, [content.resource_id]: transformed };
    } catch (e) {
      console.error('[dateSyncDriver] Patch failed:', e);
      return currentMap;
    }
  },
};

export default dateSyncDriver;